import { InteractionRequiredAuthError, PublicClientApplication, type SilentRequest } from "@azure/msal-browser";
import config from "@sg-protect/runtime-config";

const requestScopes: string[] = ["openid", "profile"];

interface AuthenticationResult {
    idTokenClaims: IdTokenClaims;
    idToken: string;
}

interface IdTokenClaims {
    roles?: string[];
}

type SilentRequestOptions = Omit<SilentRequest, "scopes">;

export const msalManagementInstance = new PublicClientApplication({
    auth: {
        clientId: config.get().app_registrations.archive,
        authority: "https://login.microsoftonline.com/organizations"
    },
    cache: {
        cacheLocation: "localStorage"
    }
});

let initializePromise: Promise<void> | null = null;

export const initializeMsal = (): Promise<void> => {
    if (!initializePromise) {
        initializePromise = msalManagementInstance.initialize();
    }

    return initializePromise;
};

export const acquireMsalManagementToken = async (request: SilentRequestOptions = {}): Promise<AuthenticationResult> => {
    await initializeMsal();

    try {
        return await msalManagementInstance.acquireTokenSilent({ scopes: requestScopes, ...request });
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const baseUrl = window.location.origin;
            const redirectUri = `${baseUrl}/archives/auth`;
            // https://learn.microsoft.com/en-us/entra/identity-platform/msal-error-handling-js
            await msalManagementInstance.acquireTokenRedirect({
                scopes: requestScopes,
                redirectUri,
                ...request
            });
        }
        throw error;
    }
};
